// extracted by mini-css-extract-plugin
export default {"keyboard":"keyboard_keyboard__eMizN","row":"keyboard_row__xvvQc","key":"keyboard_key__5qsgc"};